<template>
    <svg t="1610003130318" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4428" :width="size" :height="size">
        <path
            d="M582.2 130.44c-40.63-13.14-70.2 23.9-70.2 23.9s-29.58-37.04-70.2-23.9c-40.63 13.14-77.37 63.63-36.15 134.14C446.87 335.08 512 349.12 512 349.12s65.13-14.04 106.35-84.54c41.23-70.51 4.48-121-36.15-134.14z"
            fill="#bfa66d"
            p-id="4429"
        ></path>
        <path
            d="M869.02 547.59H154.98V349.32c0-53.05 43.41-96.46 96.46-96.46h521.13c53.05 0 96.46 43.41 96.46 96.46v198.27h-0.01z"
            fill="#bdab82"
            p-id="4430"
        ></path>
        <path
            d="M482.52 572.43H246.87V465.04c0-21.48 17.58-39.06 39.06-39.06h157.53c21.48 0 39.06 17.58 39.06 39.06v107.39zM777.13 572.43H541.48V465.04c0-21.48 17.58-39.06 39.06-39.06h157.53c21.48 0 39.06 17.58 39.06 39.06v107.39z"
            fill="#fff"
            p-id="4431"
        ></path>
        <path
            d="M958.11 896.38H65.89V648.65c0-66.29 54.24-120.52 120.52-120.52h651.17c66.29 0 120.52 54.24 120.52 120.52v247.73h0.01z"
            fill="#bfa66d"
            p-id="4432"
        ></path>
    </svg>
</template>
<script>
export default {
    props: {
        size: {
            type: String,
            default: "10vw"
        }
    }
};
</script>
